import { Badge, Loader } from "@mantine/core";
import { useTranslation } from "react-i18next";

import classes from "./ProductList.module.css";

export default function ProductStatusBadge({ status }) {
  const { t } = useTranslation("pim");
  let color = "gray";
  switch (status) {
    case "original":
      color = "gray";
      break;
    case "processing":
      color = "yellow";
      break;
    case "mapped":
      color = "green";
      break;
    case "edited":
      color = "blue";
      break;
  }
  return (
    <Badge
      variant="light"
      color={color}
      leftSection={
        status === "processing" ? <Loader size={12} color="yellow" /> : null
      }
      classNames={{ label: classes.badgeLabel }}
    >
      {t(`legacyProducts.flag.${status}`, { defaultValue: status })}
    </Badge>
  );
}
